import React from 'react'

import InfiniteScroll from "react-infinite-scroll-component";
// Components
import { LinearProgress } from 'Components';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import colors from 'Assets/sass/core/vars.scss';

import './style.scss'

const GroupListSearch = (props) => {

  const { data, messages, offset, totalItems, height, loading } = props

  const onPaginationItems = (newOffset) => {
    if(props.onNewDataPagination){
      props.onNewDataPagination(newOffset)
    }
  }

  const onClickListSearchItem = (item) => {
    if(props.onClickListSearchItem){
      props.onClickListSearchItem(item)
    }
  }

  //const resultItems = totalItems - data.length
  const resultItems = data.length
  return(
    <div>
      <InfiniteScroll
        dataLength={data.length}
        height={height}
        next={() => {
          onPaginationItems(offset + 1);
        }}
        hasMore={data.length < totalItems}
        loader={loading && <LinearProgress color="primary" />}
        endMessage={
          <div style={{ padding: 30, textAlign: "center" }}>
            <b>{`${messages ? messages['noMoreItems'] : 'There are no more items.'} (${resultItems})`}</b>
          </div>
        }
      >
        {
          data && data.map((element, index) => {
            const styleElement = { fontSize: 18, color: `#${element.color ? element.color : colors['color-primary']}`}
            return(
              <div 
                onClick={()=> onClickListSearchItem(element)} 
                className='groupListSearchItem' 
                key={`${index}-${element.name}`}
              >
                <LocalOfferIcon style={styleElement} /> {element.name}
              </div>
            )
          })
        }
      </InfiniteScroll>
    </div>
  )

}

export default GroupListSearch